import "slick-carousel/slick/slick";
import { CLASSES } from "@/scripts/helpers/constants";
import { addedLazyLoadImages } from "@/scripts/helpers/imgLazyload";
import { initWowLibrary } from "@/scripts/helpers/wowAnimation";
import contactForm from "@/modules/blocks/contact-form/index";
import modalShow from "@/modules/containers/modal/modal";
import video from "@/modules/accessability-exp-10743/video/video";
import SimpleBar from "simplebar/dist/simplebar";
import Prism from "prismjs";
import lottie from "lottie-web";
import { animationData } from "@/scripts/animation-data/animatedApiPrice";
import "prismjs/plugins/line-numbers/prism-line-numbers";
import Clipboard from "clipboard";
import reviewSlider from "@/modules/section-review/index";
import Accordion from "@/modules/containers/accordion";
import { showMore } from "@/scripts/helpers/library";

const animateClass = ".js-ready-animate";
let animateWasPlayedFlag = false;

const startVideo = () => {
  const btnVideoPreview = $(".video-preview__button");

  btnVideoPreview.click(function() {
    document.querySelector(".video-player__lazyframe").dispatchEvent(new Event("click"));
  });
};

const stopVideo = () => {
  const stopVideoHandler = () => {
    const videoIframe = $("#modal-video iframe");
    let videoURL = videoIframe.attr("src");
    videoURL = videoURL.replace("?autoplay=1", "");
    videoIframe.attr("src", "");
    videoIframe.attr("src", videoURL);
  };

  $(document).keydown(function(e) {
    if (e.keyCode == 27 && $("body").hasClass("scroll-locked")) {
      stopVideoHandler();
    }
  });

  $(".modal__container, .modal__close").on("touchstart click", function(e) {
    if (e.target == this) {
      stopVideoHandler();
    }
  });
};

const snippetPanelInit = () => {
  let scrollingBlock = document.querySelectorAll(".js-custom-scrollbar"),
    snippetPanel = $(".js-snippet-panel"),
    copyBtn = $(".js-snippet-copy-link"),
    counter = 0;

  let timer = setTimeout(function recursive() {
    let titlesArr = $(".js-animated-headline .animated-title");
    if (counter === 0) {
      showTitles(titlesArr[counter], titlesArr[titlesArr.length - 1]);
    }

    if (counter > 0) {
      showTitles(titlesArr[counter], titlesArr[counter - 1]);
    }
    counter++;

    if (counter === titlesArr.length) {
      counter = 0;
    }
    timer = setTimeout(recursive, 3000);
  }, 0);

  const showTitles = (current, previous) => {
    $(previous)
      .removeClass("is-showing")
      .addClass("is-hiding");
    $(current)
      .removeClass("is-hiding")
      .addClass("is-showing");
  };

  const pasteCodeFromTextareaToCodeTag = panel => {
    let tabsContentItems = $(panel.find(".snippet-tabs-content__item")),
      i = 0;

    if (tabsContentItems.length) {
      for (i; i < tabsContentItems.length; i++) {
        let textareaValue = $(tabsContentItems[i]).find("textarea")[0].value;
        $(tabsContentItems[i])
          .find("code")
          .html(textareaValue);
      }
      return false;
    }

    for (i; i < panel.length; i++) {
      let textareaValue = $(panel[i]).find("textarea")[0].value;
      $($(panel[i]).find("code")).html(textareaValue);
    }
  };

  const changeCopyCodeBtnView = $this => {
    let linkLabel = $($this).find(".snippet-copy-link__label"),
      currentText = linkLabel.text(),
      doneText = "Copied",
      delay = 2000;

    linkLabel.html(doneText);
    $($this).addClass("copied-label");

    setTimeout(function() {
      if (currentText !== doneText) {
        linkLabel.html(currentText);
        $($this).removeClass("copied-label");
      }
    }, delay);
  };

  const addLabelActiveTab = el => {
    let mobileLabel = $(".js-snippet-tab-name__label-mobile");

    if (typeof el === "undefined") {
      mobileLabel.html($(".nav-tabs__item.is-active a").text());
      return;
    }
    mobileLabel.html(el.text());
  };

  const init = () => {
    const snippetContentItem = $(".snippet-tabs-content__item");
    new Clipboard(".js-snippet-copy-link");

    $(".js-snippet-tab-name__label-mobile").on("click", function(e) {
      e.stopPropagation();
      e.preventDefault();
      $(this).toggleClass(CLASSES.IS_ACTIVE);
      $(".nav-tabs").toggleClass(CLASSES.IS_ACTIVE);
    });

    $(".snippet-language").on("click", function(e) {
      e.preventDefault();
      $(".js-snippet-tab-name__label-mobile").removeClass(CLASSES.IS_ACTIVE);
      $(".nav-tabs").removeClass(CLASSES.IS_ACTIVE);
    });

    for (let i = 0; i < snippetContentItem.length; i++) {
      let tab = snippetContentItem[i];
      let clipboard = $(tab).find("textarea");

      clipboard.val(
        clipboard
          .val()
          .replace(/<br\s*[\/]?>/gi, "\n")
          .replace(/\\t/gi, "   ")
      );
    }

    addLabelActiveTab();

    const apiFeaturesWl = $(".page-section--api-features-wl");
    
    if (apiFeaturesWl.length) {
      const snippetTabTrigger = $(".snippet-tabs__item");
      
      snippetTabTrigger.click(function() {
        let tabItem = $(this).attr("data-tab-item");
        let snippetContainer = $(".snippet-tabs-container");
        var tabWidth = snippetTabTrigger.outerWidth() + 8;
        var offsetLeft;

        if (tabItem == "1") {
          var offsetLeft = 0;
        } else if (tabItem == "2") {
          var offsetLeft = tabWidth;
        } else if (tabItem == "3") {
          var offsetLeft = tabWidth * 2;
        } else if (tabItem == "4") {
          var offsetLeft = tabWidth * 3;
        } else if (tabItem == "5") {
          var offsetLeft = tabWidth * 4;
        } else if (tabItem == "6") {
          var offsetLeft = tabWidth * 5;
        } else if (tabItem == "7") {
          var offsetLeft = tabWidth * 6;
        }

        snippetContainer.animate({
          scrollLeft: offsetLeft
        }, 600)
      });
    }

    $(".js-snippet-tab .snippet-tabs__item").on("click keyup", function() {
      $(".js-snippet-tab .snippet-tabs__item").removeClass(CLASSES.IS_ACTIVE);
      snippetContentItem.removeClass(CLASSES.IS_ACTIVE);
      snippetContentItem.removeClass("animated");
      $(this).addClass(CLASSES.IS_ACTIVE);
      $(this).addClass("animated");
      let match1 = $(".snippet-tabs__item.is-active").attr("data-tab-item");
      const snippetContentActive = $(
        `.snippet-tabs-content.is-active .snippet-tabs-content__item[data-tab-content-item="${match1}"]`
      );

      snippetContentActive.toggleClass(CLASSES.IS_ACTIVE);
      snippetContentActive.toggleClass("animated");

      $(snippetContentItem.find("textarea")).removeAttr("id");
      $($(".snippet-tabs-content__item.is-active").find("textarea")).attr(
        "id",
        "clipboard"
      );
    });

    const tabHandler = () => {
      const tabTrigger = $(".nav-tabs__item");
      const tabContent = $(".snippet-tabs-content");

      tabTrigger.click(function() {
        tabTrigger.removeClass(CLASSES.IS_ACTIVE);
        tabContent.removeClass(CLASSES.IS_ACTIVE);
        $(this).addClass(CLASSES.IS_ACTIVE);
        let match2 = $(".nav-tabs__item.is-active a").attr("data-tab-toggle");
        snippetContentItem.removeClass(CLASSES.IS_ACTIVE);
        $(".snippet-tabs__item").removeClass(CLASSES.IS_ACTIVE);

        $(".snippet-tabs__item[data-tab-item = 1]").addClass(CLASSES.IS_ACTIVE);

        $(`.snippet-tabs-content[data-tab-language="${match2}"]`).addClass(
          CLASSES.IS_ACTIVE
        );
        $(`.snippet-tabs-content[data-tab-language="${match2}"]`)
          .find($(".snippet-tabs-content__item[data-tab-content-item = 1]"))
          .addClass(CLASSES.IS_ACTIVE);
        addLabelActiveTab($(this));
        $(snippetContentItem.find("textarea")).removeAttr("id");
        $($(".snippet-tabs-content__item.is-active").find("textarea")).attr(
          "id",
          "clipboard"
        );
      });
    };

    tabHandler();

    pasteCodeFromTextareaToCodeTag(snippetPanel);

    copyBtn.on("click", function() {
      changeCopyCodeBtnView(this);
    });
  };

  // init custom scroll
  if (scrollingBlock !== null) {
    for (let i = 0; i < scrollingBlock.length; i++) {
      const simpleBar = new SimpleBar(scrollingBlock[i], {
        autoHide: true,
        forceVisible: false
      });
    }
  }

  Prism.hooks.add("complete", function() {
    $(".snippet-body pre").addClass("is-show");
  });

  init();
};

const inView = function(element) {
  const win = $(window);
  const obj = element;
  const heightViewport = win.height() / 2;
  const scrollPosition = win.scrollTop();
  const visibleArea = win.scrollTop() + win.height();
  const halfVisibleArea = visibleArea - heightViewport;
  const objEndPos = obj.offset().top;

  return halfVisibleArea >= objEndPos && scrollPosition <= objEndPos;
};

const dataAnimation = () => {
  let params = {
    container: document.getElementById("api-price"),
    renderer: "canvas",
    loop: false,
    autoplay: true,
    animationData: animationData
  };

  let anim;
  anim = lottie.loadAnimation(params);
};

const startAnimation = () => {
  const animateFulfillClass = ".advantages";
  const animateForm = document.querySelector(animateFulfillClass);
  const animate = document.querySelector(animateClass);

  if (animateForm !== null) {
    window.addEventListener("scroll", event => {
      if (inView($(animateForm))) {
        $(".advantages .advantages__item:nth-child(1)").addClass(
          CLASSES.IS_ACTIVE
        );

        if ($(".advantages .advantages__item:nth-child(2)").length) {
          setTimeout(() => {
            $(".advantages .advantages__item:nth-child(2)").addClass(
              CLASSES.IS_ACTIVE
            );
          }, 1000);
        }
        if ($(".advantages .advantages__item:nth-child(3)").length) {
          setTimeout(() => {
            $(".advantages .advantages__item:nth-child(3)").addClass(
              CLASSES.IS_ACTIVE
            );
          }, 2000);
        }
        if ($(".advantages .advantages__item:nth-child(4)").length) {
          setTimeout(() => {
            $(".advantages .advantages__item:nth-child(4)").addClass(
              CLASSES.IS_ACTIVE
            );
          }, 3000);
        }
      }
    });
  }

  if (animate !== null) {
    window.addEventListener("scroll", event => {
      if (!animateWasPlayedFlag && inView($(animate))) {
        dataAnimation();
        animateWasPlayedFlag = true;
      }
    });
  }
};

const reviewSliderBig = () => {
  const slider = $(".js-review-big-photo");
  const nextArrow = $(
    ".page-section--review-big-photo .js-slider-arrow .btn-next-arrow"
  );
  const prevArrow = $(
    ".page-section--review-big-photo .js-slider-arrow .btn-prev-arrow"
  );

  slider.on("init reInit afterChange", function(
    event,
    slick,
    currentSlide,
    nextSlide
  ) {
    if (!slick.$dots) {
      return;
    }

    const counter = (currentSlide ? currentSlide : 0) + 1;
    const sumCounter = slick.$dots[0].children.length;

    if (counter === 1) {
      prevArrow.addClass("is-disable");
      nextArrow.removeClass("is-disable");
    } else if (counter === sumCounter) {
      nextArrow.addClass("is-disable");
      prevArrow.removeClass("is-disable");
    } else {
      nextArrow.removeClass("is-disable");
      prevArrow.removeClass("is-disable");
    }
  });

  slider.slick({
    infinite: false,
    slidesToShow: 1,
    speed: 200,
    arrows: false,
    accessibility: true,
    ariaPolite: true,
    adaptiveHeight: true,
    dsf: false,
    dots: true,
    swipe: false,
    fade: true,
    cssEase: "ease-in",
    responsive: [
      {
        breakpoint: 959,
        settings: {
          swipe: true
        }
      }
    ]
  });

  nextArrow.click(function(e) {
    slider.slick("slickNext");
  });
  prevArrow.click(function(e) {
    slider.slick("slickPrev");
  });
};

const compareTabletHeader = () => {
  const overflowBlock = $(".table-wrapper");

  overflowBlock.scroll(function() {
    let position = $(this).scrollLeft();
    const tableTheadSticky = $(".services-comparison-table__thead.is-sticky");

    if (tableTheadSticky.length) {
      const compareHeader = ".services-comparison-table__thead .row";
      let compareHeaderWidth = $(compareHeader).width();
      $(compareHeader).css("left", "-" + position + "px");
      $(compareHeader).css("width", compareHeaderWidth + "px");
    }
  });
};

$(window).scroll(function() {
  let position = $(".table-wrapper").scrollLeft();
  const tableTheadSticky = $(".services-comparison-table__thead.is-sticky"),
    compareHeader = $(".services-comparison-table__thead .row");

  if (tableTheadSticky.length !== 1) {
    compareHeader.removeAttr("style");
  }
  if (tableTheadSticky.length) {
    compareHeader.css("left", "-" + position + "px");
  }
});


const initTableShowMore = () => {
  showMore(
    ".js-services-comparison-table",
    ".page-section--competition .js-button-show-more",
    undefined,
    true
  );
};

function stickyTableHeader() {
  const targetWidth = $(".services-comparison-table__tbody").width();

  $(window).scroll(function() {
    const fromTop = window.pageYOffset,
      tableHeader = $(".services-comparison-table__thead"),
      startPoint = $(".js-services-comparison-table"),
      offsetTop = startPoint.offset().top,
      offsetBottom = startPoint.innerHeight(),
      stopPoint = offsetTop + offsetBottom,
      tabletBreakpoint = 960,
      windowWidth = $(window).width();

    var marginTop = 0;
    const headerSticky = $(".pinned-header");

    if (headerSticky && tabletBreakpoint < windowWidth) {
      marginTop = 76;
    } else {
      marginTop = 76;
    }

    if (
      fromTop >= offsetTop - marginTop &&
      fromTop <= stopPoint - (marginTop + tableHeader.height())
    ) {
      tableHeader.addClass("is-sticky");
      startPoint.addClass("is-active");
    } else {
      tableHeader.removeClass("is-sticky");
      startPoint.removeClass("is-active");
    }
  });

  $(".services-comparison-table__thead").css("max-width", targetWidth);

  if ($(".row-price").length === 1) {
    $(".services-comparison-table__tbody").addClass("single-price");
  }

  if (!$(".row-price").length) {
    $(".services-comparison-table__tbody").addClass("no-price");
  }
}

$(document).ready(function() {
  addedLazyLoadImages();
  contactForm();
  initWowLibrary();
  startAnimation();
  modalShow();
  startVideo();
  video();
  stopVideo();
  reviewSlider();
  reviewSliderBig();
  stickyTableHeader();
  Accordion();
  compareTabletHeader();
  initTableShowMore();

  $(window).on("resize", function(){
    $(".services-comparison-table__thead .row").css("width", "inherit")
    stickyTableHeader();
  });

  window.addEventListener("orientationchange",()=>{
    $(".services-comparison-table__thead .row").css("width", "inherit")
    stickyTableHeader();
  })

  $("[data-micromodal-trigger]").click(function(e) {
    e.preventDefault();
  });
});

snippetPanelInit();
